import React from 'react'
import { RichTextRenderer } from '../../../lib/components'
import { CMSOpportunityDetailsRiskInvolvedType } from '../../../lib/types'
import { CmsSectionText } from './cms-section-text-content'

const CMSRiskInvolved = ({
  risksInvolved,
}: {
  risksInvolved?: CMSOpportunityDetailsRiskInvolvedType
}) => {
  if (!risksInvolved?.text?.length) {
    return null
  }

  return (
    <CmsSectionText dataTestId='cms-risks-involved-text'>
      <RichTextRenderer content={risksInvolved.text} variant='opportunity-details' />
    </CmsSectionText>
  )
}

export { CMSRiskInvolved }
